import { CheckException } from '@treasury/domain/arp';

export const exceptionNeedsDecision = (exception: CheckException) =>
    !exception.decidedToday && !exception.protected;

export const exceptionsDecidedToday = (exception: CheckException): boolean =>
    exception.decidedToday || exception.protected;
